import React, { useState, useEffect, useContext } from 'react';
import { useSelector } from 'react-redux';
import { useParams, useHistory, useRouteMatch } from "react-router-dom";
import styles from './index.module.scss';
import axios from 'axios';
import { toast } from 'react-toastify';

// componentes
import Select from 'react-select';
import useIsMounted from 'ismounted';
import { Modal, Container, Card, Row, Col, Form, Button, InputGroup, Spinner, Alert, OverlayTrigger, Tooltip, Badge} from 'react-bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRandom } from '@fortawesome/free-solid-svg-icons';

import { intersectObject, copiaCampo } from './../../../../Funcoes';
import { FichaComponent } from './components';

// contexto
import { PainelContexto } from './../../../PainelContexto';
import InputDataCombo from '../../../../Componentes/InputDataCombo';
import InputHora from '../../../../Componentes/InputHora';
import Confirmar from '../../../../Componentes/Confirmar';
import moment from 'moment';

// faz o cadastro
export default function ModalEditar({
    
}){

    // dados
    const isMounted = useIsMounted();
    const { path, url } = useRouteMatch();
    const painelContextoDados = useContext(PainelContexto);
    const history = useHistory();

    // parametros da url
    const {
        id = null
    } = useParams();

    // prepara
    const dadosPadrao = {
        id: null,
        idEmpresa: null,
        idUsuario: null,
        dados: null
    }
    
    // estados
    const [ dados, alterarDados ] = useState({...dadosPadrao});
    const [ dadosEmpresa, alterarDadosEmpresa ] = useState({});
    const [ dadosUsuario, alterarDadosUsuario ] = useState({});
    const [ dadosIntegracaoSistema, alterarDadosIntegracaoSistema ] = useState({});
    const [ empresaPossuiIntegracaoSistema, alterarEmpresaPossuiIntegracaoSistema ] = useState('N');
    const [ mostrar, alterarMostrar ] = useState(true);
    const [ salvando, alterarSalvando ] = useState(false);
    const [ carregando, alterarCarregando ] = useState(true);
    const [ confirmar, alterarConfirmar ] = useState(null);
    const [ consultarAoSair, alterarConsultarAoSair ] = useState(false);
    
    // prepara array com permissões
    const permissoes = [
        {value: 'projetista', label: 'Projetista'},
        {value: 'tecnico', label: 'Técnico'},
        {value: 'vendedor', label: 'Vendedor'},
        {value: 'viabilidade', label: 'Viabilidade'}
    ];

    // inicializa
    useEffect(() => {
        
        // verifica se enviado o id
        if(id){

            // consulta
            consultarId();
        }
    }, []);

    // consulta dados do usuário
    async function consultarId(){

        // cria o carregamento
        alterarCarregando(true);

        try{
            
            // faz a requisição
            let { data } = await axios.get(`/empresas/pedidosIntegracao/${id}`);
            
            // define os dados
            alterarDados({...data.dados});
            alterarDadosEmpresa({...data.dadosEmpresa});
            alterarDadosUsuario({...data.dadosUsuario});
            alterarDadosIntegracaoSistema({...data.dadosIntegracaoSistema});
            alterarEmpresaPossuiIntegracaoSistema(data.empresaPossuiIntegracaoSistema);

        }catch(e){
            console.log('pegou o erro')
        }finally{
            if (isMounted.current) {
                alterarCarregando(false);
            }
        }

    }

    // função para concluir integração
    async function concluir(){

        // define o salvando
        alterarSalvando(true);

        try{

            // faz a requisição
            let { data } = await axios.post(`/empresas/pedidosIntegracao/${id}/concluir`);

            // sucesso

            // altera
            alterarSalvando(false);
            alterarMostrar(false);
            
            // monta a url para retroceder
            let urlBack = url.split("/pedidosIntegracao").map((parte, i) => i > 0 ? '/pedidosIntegracao' : parte).join('');
            
            // volta e dá refresh pra atualizar a listagem
            history.push(urlBack, {refresh: true});

        }catch({response}){
            // erro

            // informa erros

            // informa erro
            toast(<>
                <div
                    style={{background: '#ff6271'}}
                >
                    <div className="toast-header">
                        <strong className="mr-auto">Pedido não pôde ser concluído</strong>
                        <button 
                            className="ml-2 mb-1 close btn-outline-light outline-0"
                        >
                        </button>
                    </div>
                    <div className="toast-body text-light">
                        {
                            (response && response.data) &&
                            Object.keys(response.data).map((erro) => <p className={'m-0'} key={erro}>{response.data[erro]}<br/></p>)
                        }
                    </div>
                </div>
            </>);

        }finally{
            // finalizou

            // altera
            alterarSalvando(false);
        }
    }

    // finaliza
    async function adicionarIntegracao(){

        // salva registro
        alterarSalvando(true);

        // faz a requisição
        try{

            // pega dados
            let dadosSalvar = intersectObject(dadosPadrao, dados);

            // faz a requisição
            let { data } = await axios.post(`/empresas/integracaoSistemas`, {
                dados: {
                    idEmpresa: dadosEmpresa.id,
                    idIntegracaoSistema: dadosIntegracaoSistema.id
                }
            });

            // mensagem de cadastro realizado com sucesso
            toast(({closeToast }) => <>
                <div className="toast-header">
                    <strong className="mr-auto">Integração adicionada!</strong>
                    <button 
                        onClick={closeToast} 
                        className="ml-2 mb-1 close btn-outline-light outline-0"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            </>);

            // altera
            alterarSalvando(false);
            alterarConfirmar(null);
            alterarEmpresaPossuiIntegracaoSistema('S');
            
            // verifica se deve consular ao sair
            alterarConsultarAoSair(true);

        }catch({response}){

            // informa erro
            toast(<>
                <div
                    style={{background: '#ff6271'}}
                >
                    <div className="toast-header">
                        <strong className="mr-auto">Integração não pôde ser adicionada</strong>
                        <button 
                            className="ml-2 mb-1 close btn-outline-light outline-0"
                        >
                        </button>
                    </div>
                    <div className="toast-body text-light">
                        {
                            (response && response.data) &&
                            Object.keys(response.data).map((erro) => <p className={'m-0'} key={erro}>{response.data[erro]}<br/></p>)
                        }
                    </div>
                </div>
            </>);

        }finally{
            if (isMounted.current) {
                alterarSalvando(false);
            }
        }
    }

    return <>
        <Confirmar config={confirmar} alterar={alterarConfirmar}/>
    
        {(!confirmar || !confirmar.aberto) && <Modal 
            show={mostrar}
            centered
            onExited={() => {

                // monta a url para retroceder
                let urlBack = url.split("/pedidosIntegracao").map((parte, i) => i > 0 ? '/pedidosIntegracao' : parte).join('');
                
                // volta e dá refresh pra atualizar a listagem
                history.push(urlBack, {
                    aPartirDe: consultarAoSair ? null : 'visualizarPedidoIntegracao'
                });
                
                // fecha
                alterarMostrar(false);
            }}
            onHide={() => {

                // fecha
                alterarMostrar(false);
            }}
            size={'md'}
        >
            <Modal.Header className='border-0'>
                <Modal.Title 
                    as='h5' 
                    className={[
                        'text-center w-100',
                        'text-success'
                    ].join(' ')}
                >
                    {!carregando && <>
                        {dadosEmpresa.razaoSocial} <small>({dadosIntegracaoSistema.nome})</small>
                        {dados.concluido === 'S' && <small>
                            <br/>
                            Pedido concluído - <small>{moment(dados.dataConcluido).format('DD/MM/YYYY')}</small>
                        </small>}
                    </>}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className={'pt-0'}>
                {
                    carregando ?
                    <Col align="center">
                        <Spinner animation="border" />
                    </Col>
                    : <FichaComponent>
                        <Container>
                            <Form.Row>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>Integração com</Form.Label>
                                        <Form.Control
                                            value={dadosIntegracaoSistema.nome || ''}
                                            disabled
                                        />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>Pedido em</Form.Label>
                                        <Form.Row className='align-items-center'>
                                            <Col sm={7} xs={7}>
                                                <InputDataCombo
                                                    size="sm"
                                                    data={dados.dataCadastro}
                                                    disabled
                                                />
                                            </Col>
                                            às
                                            <Col>
                                                <InputHora
                                                    value={moment(dados.dataCadastro).format('HH:mm:ss')}
                                                    disabled
                                                />
                                            </Col>
                                        </Form.Row>
                                    </Form.Group>
                                </Col>
                            </Form.Row>
                            <Form.Row>
                                <Col>
                                    <Form.Group>
                                        <Form.Label>Razão social</Form.Label>
                                        <Form.Control
                                            value={dadosEmpresa.razaoSocial || ''}
                                            disabled
                                        />
                                    </Form.Group>
                                </Col>
                            </Form.Row>

                            <Form.Row>
                                <Col md={8}>
                                    <Form.Group>
                                        <Form.Label>Nome do usuário</Form.Label>
                                        <Form.Control
                                            value={dadosUsuario.nome || ''}
                                            disabled
                                        />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Label>Permissão</Form.Label>
                                    <Select
                                        className="select-ficha"
                                        options={permissoes}
                                        defaultValue={permissoes.filter((e) => dadosUsuario.permissao === e.value)[0]}
                                        isMulti={false}
                                        placeholder='Permissão'
                                        isDisabled
                                    />
                                </Col>
                            </Form.Row>
                            
                            <Form.Row>
                                <Col md={8}>
                                    <Form.Group>
                                        <Form.Label>Responsável</Form.Label>
                                        <Form.Control
                                            value={dados.dados.nome || ''}
                                            disabled
                                        />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Label>Telefone</Form.Label>
                                        <Form.Control
                                            value={dados.dados.telefone || ''}
                                            disabled
                                        />
                                </Col>
                            </Form.Row>
                            <Form.Row>
                                <Col>
                                    <Form.Label>E-mail</Form.Label>
                                        <Form.Control
                                            value={dados.dados.email || ''}
                                            disabled
                                        />
                                </Col>
                            </Form.Row>

                            {dados.cancelado === 'S' && <>
                                <hr/>
                                <Form.Row>
                                    <Col>
                                        <Form.Group>
                                            <Form.Label>Cancelado em</Form.Label>
                                            <Form.Row className='align-items-center'>
                                                <Col sm={7} xs={7}>
                                                    <InputDataCombo
                                                        size="sm"
                                                        data={dados.dataCancelado}
                                                        disabled
                                                    />
                                                </Col>
                                                às
                                                <Col>
                                                    <InputHora
                                                        value={dados.dataCancelado}
                                                        disabled
                                                    />
                                                </Col>
                                            </Form.Row>
                                        </Form.Group>
                                    </Col>
                                </Form.Row>
                                <Form.Row>
                                    <Col>
                                        <Form.Label>Motivo cancelamento</Form.Label>
                                            <textarea
                                                className="form-control"
                                                style={{minHeight: 50, fontSize: 14}}
                                                value={dados.motivoCancelado || ''}
                                                disabled
                                            ></textarea>
                                    </Col>
                                </Form.Row>
                            </>}
                        </Container>
                    </FichaComponent>
                }
            </Modal.Body>
            <Modal.Footer className='border-0 d-flex justify-content-between'>
                <Button
                    variant='secondary'
                    onClick={() => {alterarMostrar(false)}}
                    disabled={salvando}
                >
                    <span>Fechar</span>
                </Button>
                {(dados.cancelado === 'N' && empresaPossuiIntegracaoSistema === 'N') && <Button
                        onClick={() => {

                            // confirma
                            alterarConfirmar({
                                aberto: true,
                                titulo: 'Adicionar integração',
                                texto: `Tem certeza que deseja adicionar esta integração para a empresa?`,
                                textoBotao: 'Adicionar',
                                variantConfirmar: 'success',
                                variantCancelar: 'secondary',
                                backdrop: true,
                                aoConfirmar: () => {

                                    // conclui
                                    adicionarIntegracao();
                                },
                                aoCancelar: () => {
                                    // ao cancelar
                                },
                                aoFechar: () => {
                                    // ao fechar
                                }
                            })
                        }}
                        variant='info'
                        disabled={salvando}
                    >
                        <span>Integrar</span>
                    </Button>
                }
                {(dados.cancelado === 'N' && empresaPossuiIntegracaoSistema === 'S' && dados.concluido === 'N') && <Button
                    onClick={() => {

                        // confirma
                        alterarConfirmar({
                            aberto: true,
                            titulo: 'Concluir integração',
                            texto: `Tem certeza que deseja concluir esta integração?`,
                            textoBotao: 'Concluir',
                            variantConfirmar: 'success',
                            variantCancelar: 'secondary',
                            backdrop: true,
                            aoConfirmar: () => {

                                // conclui
                                concluir();
                            },
                            aoCancelar: () => {
                                // ao cancelar
                            },
                            aoFechar: () => {
                                // ao fechar
                            }
                        })
                    }}
                    variant='success'
                    disabled={salvando}
                >
                    {salvando ? 
                        <>
                            <FontAwesomeIcon className="icone" pulse icon={["fas", 'spinner']} />
                            <span>Concluindo</span>
                        </> : 
                        <span>Concluir</span>
                    }
                    </Button>
                }
            </Modal.Footer>
        </Modal>}
    </>
}   